<template>
  <div class="bg_starry">
    <div id="stars1" class="stars"></div>
    <div id="stars2" class="stars"></div>
    <div id="stars3" class="stars"></div>
  </div>
</template>

<script>
export default {
  name: 'StarryBG'
}
</script>

<style lang="scss">
// design by https://codepen.io/saransh/pen/BKJun
@function multiple-box-shadow ($n) {
  $value: '#{random(2000)}px #{random(2000)}px #FFF';
  @for $i from 2 through $n {
    $value: '#{$value} , #{random(2000)}px #{random(2000)}px #FFF'
  }
  @return unquote($value)
}

$shadows-small: multiple-box-shadow(700);
$shadows-medium: multiple-box-shadow(200);
$shadows-big: multiple-box-shadow(100);


.stars {
  position: absolute;
  left: 0;
  top: 0;
}

#stars1 {
  width: 1px;
  height: 1px;
  background: transparent; // box-shadow: $shadows-small;
  animation: animStar 250s linear infinite;

  &:after {
    content: " ";
    position: absolute;
    top: 0px;
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: $shadows-small;
  }
}

#stars2 {
  width: 2px;
  height: 2px;
  background: transparent; // box-shadow: $shadows-medium;
  animation: animStar 300s linear infinite;

  &:after {
    content: " ";
    position: absolute;
    top: 0px;
    width: 2px;
    height: 2px;
    background: transparent;
    box-shadow: $shadows-medium;
  }
}

#stars3 {
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow: $shadows-big;
  animation: animStar 350s linear infinite;

  &:after {
    content: " ";
    position: absolute;
    top: 0px;
    width: 3px;
    height: 3px;
    background: transparent;
    box-shadow: $shadows-big;
  }
}

@keyframes animStar {
  from {
    transform: translateX(0px)
  }
  to {
    transform: translateX(-2000px);
  }
}
</style>




// WEBPACK FOOTER //
// StarryBg.vue?35676a33